import { render, staticRenderFns } from "./fromWx.vue?vue&type=template&id=5afc43de&scoped=true&"
import script from "./fromWx.vue?vue&type=script&lang=js&"
export * from "./fromWx.vue?vue&type=script&lang=js&"
import style0 from "./fromWx.vue?vue&type=style&index=0&id=5afc43de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc43de",
  null
  
)

export default component.exports